import {KpiItemDefault} from './Kpi.Item.Default'
import {KpiItemUnderline} from './Kpi.Item.Underline'

import type {ClassNameValue} from 'tailwind-merge'
import type {ComponentProps} from 'react'

// Component KpiItemDefault and KpiItemUnderline should use this interface as props
export interface KpiItemBaseProps extends Omit<ComponentProps<'div'>, 'className'> {
  /** class names */
  className?: ClassNameValue
  /** big string - when using a number a count up animation will be triggered */
  value?: string | number
  /** string right from value */
  unit?: string
  /** string positioned after the divider */
  title?: string
  /** string positioned after the title */
  subtitle?: string
  /** if the values is of type number, it is animated */
  variant?: 'COUNT_UP' | 'COUNT_DOWN' | null
}

// KPI item has two different visualizations
export interface KpiItemProps extends KpiItemBaseProps {
  visualization?: 'DEFAULT' | 'UNDERLINE' | null
}

/**
 * KpiItem component
 * shows information with a large text value with unit side by side.
 * Has two different visualizations: DEFAULT and UNDERLINE
 */
export const KpiItem = ({visualization, ...restProps}: KpiItemProps) => {
  visualization = visualization ?? 'DEFAULT'

  if (visualization === 'DEFAULT') {
    return <KpiItemDefault {...restProps} />
  }
  if (visualization === 'UNDERLINE') {
    return <KpiItemUnderline {...restProps} />
  }
  // make sure that all cases for visualization are handled
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const exhaustiveVisualizationCheck: never = visualization
  return null
}
